import {
  AboutYouModel,
  DrivingHistoryApiResponseModel,
  KeyValuePair,
  CoverDetailsDropDowns,
  CarInsuranceVehicleModel,
  AdditionalDriverDropDowns,
  AddressDetailsDropDowns,
  DealerLoginResponseModel,
  DealerHomepageOptions,
  InsuranceJourneyState,
  DealerDashboardItem,
  ActivateDealerQuoteDto,
  ActivateResponse
} from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';
import {
  CustomerDetailsDto,
  MarketingPreferencesDto,
  MarketingPreferencesResponse,
  RetrieveQuoteRequestType
} from './Models/InsuranceJourney';

export class CarInsuranceApi {
  async GetDropDownValuesForVehicleMakeAsync(
    token: string,
    successCallback: (vehicleMakes: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/VehicleMake';

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForVehicleModelsAsync(
    make: string,
    token: string,
    successCallback: (vehicleMakes: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/VehicleModel?make=${make}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForVehicleSpecificationsAsync(
    make: string,
    model: string,
    fuelType: string,
    transmissionType: string,
    noOfDoors: string,
    token: string,
    successCallback: (vehicleMakes: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/vehiclespecification?make=${make}&model=${model}&fuelType=${fuelType}&transmissionType=${transmissionType}&noOfDoors=${noOfDoors}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForVehicleDetailsAsync(
    tiaProductCode: string,
    token: string,
    successCallback: (vehciledetails: CarInsuranceVehicleModel) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/vehicledetails?tiaProductCode=${tiaProductCode}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForDrivingHistoryAsync(
    dateOfBirth: Date | undefined,
    token: string,
    successCallback: (apiResponse: DrivingHistoryApiResponseModel) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/drivinghistory${dateOfBirth === undefined || dateOfBirth === null ? '' : `?dateOfBirth=${new Date(dateOfBirth).toISOString()}`}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForCoverDetailsAsync(
    token: string,
    successCallback: (coverDetailsList: CoverDetailsDropDowns) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/CoverDetails';

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForAddressDetailsAsync(
    token: string,
    successCallback: (AddressDetailsList: AddressDetailsDropDowns) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/AddressDetails';

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetAboutYouDropDownListsAsync(
    token: string,
    successCallback: (aboutYouList: AboutYouModel) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/yourdetails';

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetOccupationsBySearchAsync(
    searchText: string,
    token: string,
    successCallback: (occupations: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/occupation?searchText=' + searchText;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetIndustriesBySearchAsync(
    searchText: string,
    token: string,
    successCallback: (industries: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/industry?searchText=' + searchText;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetTrackingDevicesBySearchAsync(
    searchText: string,
    token: string,
    successCallback: (trackingDevices: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/trackingdevice?searchText=' + searchText;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForAdditionalDriverAsync(
    token: string,
    successCallback: (AdditionalDriverList: AdditionalDriverDropDowns) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/AdditionalDriver';

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async AuthenticateDealer(
    username: string,
    password: string,
    fullName: string,
    tiaProductCode: string,
    successCallback: (dealerLoginResponse: DealerLoginResponseModel) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const url = '/api/carinsurance/dealerlogin';
    const data = { username, password, tiaProductCode, fullName };

    await new ApiHelper().postDataAsync(
      url,
      data,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDealerHomepageOptionsAsync(
    dealerCode: string,
    tiaProductCode: string,
    token: string,
    successCallback: (homePageOptions: DealerHomepageOptions) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/dealeroptions?username=${dealerCode}&tiaproductcode=${tiaProductCode}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetQuoteAsync(
    token: string,
    successCallback: (insuranceState: InsuranceJourneyState) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/quote`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetMobiliseQuoteAsync(
    token: string,
    tiaProductCode: string,
    postcode: string,
    dateOfBirth: string,
    vPol: string,
    successCallback: (insuranceState: InsuranceJourneyState) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/mobilisequote?tiaProductCode=${tiaProductCode}&postcode=${postcode}&dateOfBirth=${dateOfBirth}&vpol=${vPol}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async RegisterPolicyAsync(
    quote: InsuranceJourneyState,
    token: string,
    successCallback: (quote: InsuranceJourneyState) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const url = '/api/carinsurance/registerpolicy';

    await new ApiHelper().postDataSecureAsync(
      url,
      quote,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async SaveQuoteAsync(
    quote: InsuranceJourneyState,
    token: string,
    successCallback: (quote: InsuranceJourneyState) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const url = '/api/carinsurance/savequote';

    const { insuranceNavigationStatus, staticData, ...quoteData } = quote;
    console.log('Skipping below properties');
    console.log(insuranceNavigationStatus);
    console.log(staticData);

    await new ApiHelper().postDataSecureAsync(
      url,
      quoteData,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDealerQuoteListAsync(
    dealerId: string,
    token: string,
    successCallback: (dashboardReport: DealerDashboardItem[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal,
    displayMonths?: number
  ): Promise<void> {
    let dataUrl = `/api/carinsurance/DealerQuoteList?dealerGateway=${dealerId}`;

    if (displayMonths) {
      dataUrl += `&displayMonths=${displayMonths}`;
    }

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetDropDownValuesForVoluntaryExcessAsync(
    token: string,
    successCallback: (YourQuoteList: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/VoluntaryExcess';

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetQuoteDocument(
    documentId: number,
    token: string,
    successCallback: (documentContent: string) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/carinsurance/quotedocument?documentId=' + documentId;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async RetrieveQuoteAsync(
    payload: RetrieveQuoteRequestType,
    token: string,
    successCallback: (quote: InsuranceJourneyState) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const url = '/api/carinsurance/retrievequote';

    await new ApiHelper().postDataSecureAsync(
      url,
      payload,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetMarketingPreferencesAsync(
    payload: CustomerDetailsDto,
    token: string,
    callBackOnSuccess: (
      marketingPreferences: MarketingPreferencesResponse
    ) => void,
    callBackOnFailure: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const url = '/api/carinsurance/GetMarketingPreferences';

    await new ApiHelper().postDataSecureAsync(
      url,
      payload,
      token,
      callBackOnSuccess,
      callBackOnFailure,
      signal
    );
  }

  async UpdateMarketingPreferences(
    payload: MarketingPreferencesDto,
    token: string,
    callBackOnSuccess: (flag: boolean) => void,
    callBackOnFailure: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const url = '/api/carinsurance/UpdateMarketingPreferences';

    await new ApiHelper().postDataSecureAsync(
      url,
      payload,
      token,
      callBackOnSuccess,
      callBackOnFailure,
      signal
    );
  }

  async ActivateDealerQuoteAsync(
    activateDealerQuote: ActivateDealerQuoteDto,
    token: string,
    successCallback: (activateStatus: ActivateResponse) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const url = '/api/carinsurance/activateDealerQuote';

    await new ApiHelper().postDataSecureAsync(
      url,
      activateDealerQuote,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async CustomerSelfRegistrationEmail(
    tiaProductCode: string,
    dealerId: number,
    emailAddress: string,
    token: string,
    successCallback: (successfulResponse: boolean) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/CustomerSelfRegistrationEmail?tiaProductCode=${tiaProductCode}&dealerId=${dealerId}&emailAddress=${emailAddress}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GenerateQuoteDocument(
    quoteId: number,
    documentType: string,
    token: string,
    successCallback: (documentContent: string) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/GenerateQuoteDocument?quoteId=${quoteId}&documentType=${documentType}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async GetPolicyDocument(
    scheme: string,
    tiaProductCode: string,
    documentType: string,
    token: string,
    successCallback: (documentContent: string) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/carinsurance/policydocument?scheme=${scheme}&brandId=${tiaProductCode}&documentType=${documentType}`;
    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
